<template>
  <v-dialog v-model="showModal" max-width="850px" persistent>
    <v-card class="pa-4">
      <v-card-title>
        <h2>
        Llamadas agendadas
        </h2>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <vue-perfect-scrollbar>
            <v-card-text class="customer-dues pa-0">
              <v-container grid-list-lg fluid>
                <v-layout row wrap>
                  <v-data-table
                    :headers="headers"
                    hide-actions
                    class="w-100"
                    no-data-text="No se encontraron datos"
                    :items="rows"
                    :pagination.sync="sorting">
                    <template slot="headers" slot-scope="props">
                      <th v-for="(header, index) in props.headers" :key="`header-${index}`" class="text-xs-center">
                        <span>
                          {{ header.text }}
                        </span>
                      </th>
                    </template>
                    <template slot="items" slot-scope="props">
                      <tr>
                        <td>
                          {{ getChannelName(props.item.channel_id) }}
                        </td>
                        <td width="50px">
                          {{ props.item.schedule_date | formatDate }}
                        </td>
                        <td>
                          {{ props.item.to }}
                        </td>
                        <td>
                          {{ $store.getters.status(props.item.ns_status_id).status || 'Sin especificar' }}
                        </td>
                        <td>
                          {{ $store.getters.subStatus(props.item.ns_sub_status_id).name || 'Sin especificar'}}
                        </td>
                        <td>
                          <v-chip small v-if="props.item.status_id === 1" class="white--text red">
                            Programada
                          </v-chip>
                          <v-chip small v-else-if="props.item.status_id === 2" class="white--text blue">
                            En proceso
                          </v-chip>
                          <v-chip small v-else-if="props.item.status_id === 3" class="white--text green">
                            Realizada
                          </v-chip>
                          <v-chip small v-else class="white--text red">
                            Reagendada
                          </v-chip>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-layout>
              </v-container>
            </v-card-text>
          </vue-perfect-scrollbar>
        </v-card>        
      </v-card-text>
      <v-card-actions>
        <v-btn color="black" class="ml-auto" flat @click.stop="$emit('close')">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import moment from 'moment';
import _ from 'lodash';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    customer: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      showModal: false,
      headers: [
        {
          text: 'Canal',
        },
        {
          text: 'Fecha',
        },
        {
          text: 'Contacto',
        },
        {
          text: 'Estatus',
        },
        {
          text: 'Sub status',
        },
        {
          text: '',
        },
      ],
      sorting: {
        sortBy: 'local_date',
        descending: true,
      },
      rows: [],
    };
  },
  filters: {
    formatDate(date) {
      return moment.utc(date, 'YYYY-MM-DD HH:mm:ss').local().format('DD/MM/YYYY HH:mm A');
    },
  },
  methods: {
    getChannelName(channelId) {
      let result;
      const { channel } = this.$store.getters.channel(channelId);
      if (channel === 'human') {
        result = 'Humano';
      } else if (channel === 'visit') {
        result = 'Visita';
      } else {
        result = _.upperFirst(channel.toLowerCase());
      }
      return result;
    },
  },
  watch: {
    show() {
      if (this.show) {
        this.axios.get(`/customers/${this.customer.id}/notifications_pending`)
          .then((response) => {
            this.rows = response.data;
            this.showModal = true;
          })
          .catch(() => {
            // SHOW ERROR
            this.$emit('close');
          });
      } else {
        this.showModal = false;
      }
    },
  },
};
</script>

<style scoped>
  .customer-dues {
    height: 392px;
  }
  .customer-dues >>> .datatable.table {
    table-layout: fixed;
  }
  .customer-dues >>> .datatable.table td {
    padding-top: 6px !important;
    padding-bottom: 6px !important; 
    padding-right: 0px !important;
    word-break: break-all;
    white-space: normal !important;
  }
  .customer-dues >>> .datatable.table th:nth-child(2) {
    width: 150px !important;
  }
  .customer-dues >>> table.table tbody tr:first-child {
    border-top: 1px solid rgba(0,0,0,.12) !important;
  }
  .customer-dues >>> table.table tbody td {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/customer/NotificationPendingDialog.vue